/* eslint-disable react/require-default-props */

import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Text,
} from '@chakra-ui/react';

function TextField({
  label,
  name,
  value,
  errorMessage,
  helperText,
  placeholder,
  id,
  type = 'text',
  onChange,
  inputProps,
  disabled,
  required,
  isInvalid,
  ...customProps
}) {
  // const isInvalid = !!errorMessage;

  return (
    <FormControl {...customProps} isInvalid={errorMessage}>
      {label && (
        <FormLabel
          display="flex"
          htmlFor={id || label}
          fontSize={inputProps?.size == 'sm' && '14px'}
        >
          {label}{' '}
          {required && (
            <Text color="red" ml={1}>
              *
            </Text>
          )}
        </FormLabel>
      )}
      <Input
        id={id || label}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        {...inputProps}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
}

export { TextField };
